// 可以全局使用过渡期一弹窗

import Vue from 'vue'
import DialogComponent from "../components/interimDialog.vue"
const Dialog={}
Dialog.install = function(Vue){
    const DialogConstructor = Vue.extend(DialogComponent);
    const instance = new DialogConstructor();
    instance.$mount(document.createElement('div'));
    document.body.appendChild(instance.$el);
    const message_main = {
        show(){
            instance.dialogVisible = true;
        },
    }
    // //将方法挂载全局
    Vue.prototype.$myDialog = message_main;
}
export default Dialog


// WEBPACK FOOTER //
// ./src/utils/dialog.js